import React from 'react';
import { Slide } from 'react-reveal';

const Education = () => {
  return (
    <Slide bottom>
    <div id='education' className="py-10 pb-10 lg:mx-24 sm:mx-2 ">
      <div className="flex  justify-center my-10">
        <h2 className="text-3xl font-bold text-center">
          Education
        </h2>
      </div>
      <div className="flex  justify-center lg:flex-row sm:flex flex-col">
        <div className="flex-1 px-10 py-10 mx-5 shadow-xl">
         
          <h3 className="text-xl">
           BSc in CSE
          </h3>
          <p>2016 - 2021</p>
          <p>International Islamic University Chittagong</p>
          <h3 className="">GPA : 3.58 (out of 4.00)</h3>
         
          <hr />
        </div>

        <div className="flex-1 px-10 py-10 mx-5 shadow-xl">

         
        <h3 className="text-xl">
           HSc
          </h3>
          <p>2015</p>
          <p>Sitakunda University College</p>
          <h3 className="">GPA :3.92</h3>
          <hr />
        </div>


        <div className="flex-1 px-10 py-10 mx-5 shadow-xl">
         
        <h3 className="text-xl">
           SSc
          </h3>
          <p>2013</p>
          <p>Terial High School, Sitakunda</p>
          <h3 className="">CGPA :4.88</h3>
          <hr />
        </div>

      </div>

    </div>
    </Slide>
  );
};

export default Education;